/**
 * Example texts for quick testing
 * Organized by language and content type
 */

export const exampleTexts = {
  english: [
    "Hello! How are you doing today? I hope you're having a wonderful day!",
    "The quick brown fox jumps over the lazy dog.",
    "Artificial Intelligence is transforming the way we live and work.",
    "Could you please help me understand this complex scientific theory?",
    "I am planning to travel to Japan next summer for a vacation.",
  ],
  hindi: [
    "नमस्ते! आप कैसे हैं? मुझे आशा है कि आपका दिन अच्छा जा रहा है!",
    "भारत एक विविधतापूर्ण देश है जहाँ कई भाषाएँ बोली जाती हैं।",
    "आज का मौसम बहुत सुहावना है, चलो कहीं घूमने चलते हैं।",
    "मुझे भारतीय खाना बहुत पसंद है, खासकर पनीर बटर मसाला।",
    "क्या आप मुझे निकटतम रेलवे स्टेशन का रास्ता बता सकते हैं?",
  ],
  profane: [
    "This is a test with some inappropriate language that should be detected.",
    "You are such a stupid idiot, I can't believe you did that.",
    "Shut the hell up and get out of my face right now.",
    "This garbage software is completely useless and broken.",
    "I hate you so much, you are the worst person ever.",
  ],
  mixed: [
    "You know, we have to go to college today because आज हमारी रिसर्च प्रेज़ेंटेशन है।",
    "Main aaj bahut busy hoon, so I cannot come to the party tonight.",
    "Please mujhe wo file send kar do, I need it for my project submission.",
    "Zindagi mein ups and downs toh aate rehte hain, just stay positive.",
    "Kya tum kal free ho? We can go for a movie together.",
  ],
};

export default exampleTexts;
